import {
  setCurArch,
  setdisabledLower,
  setdisabledUpper,
  setIsShowExtractedMsg,
  setTopLeftViewType,
} from "@/UDTreat/udTreatSlice"
import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import {
  EArchType,
  stageControl,
  toothMovement,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"
import { globalMovement } from "@/gluelayer/core/modules/globalMovement"
import { EArchForm, ESteupModelType, ETopLeftViewType } from "@/shared/types"
import { isRetainerArch } from "@/shared/utils/tools/caseUtils"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  CircularProgress,
} from "@mui/material"
import classNames from "classnames"
import { FC, useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import ArchForm from "./ArchForm"
import GlobalMovement from "./GlobalMovement"
import IPRSpaceManagement from "./IPRSpaceManagement"
import PonticDome from "./PonticDome"

interface IProps {
  curArch: string
  disabledGMModel: boolean
  disabledArchForm: boolean
  disabledIPR: boolean
}

const { setStageCallback, setStageStep, getWasmStageData } = stageControl

const MyAccordion: FC<IProps> = ({
  curArch,
  disabledGMModel,
  disabledArchForm,
  disabledIPR,
}) => {
  const dispatch = useDispatch()
  const MyCurArch = useRef<string>(curArch)
  const {
    openCollisionCheck,
    topLeftViewType,
    isShowExtractedMsg,
    updateStaging,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const timer = useRef<any>(null)

  const [expanded, setExpanded] = useState<ESteupModelType | null>(null)
  const [isShowPonticDome, setIsShowPonticDome] = useState(false)
  const [disabledGM, setDisabledGM] = useState<boolean>(false)
  const [pageLoading, setPageLoading] = useState<boolean>(false)
  const [type, setType] = useState<EArchForm | null>(null)
  const [isSwitching, setIsSwitching] = useState(false)
  const [pendingPanel, setPendingPanel] = useState<ESteupModelType | null>(null)

  /**
   * Watch Diabled
   */
  useEffect(() => {
    if (disabledArchForm && expanded === ESteupModelType.ARCH_FORM) {
      setExpanded(null)
    }

    if (disabledIPR && expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT) {
      setExpanded(null)
    }
  }, [disabledArchForm, disabledIPR, curArch])

  useEffect(() => {
    if (
      curArch === "up" &&
      expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT
    ) {
      dispatch(setdisabledUpper(true))
      dispatch(setdisabledLower(false))
    }
    if (
      curArch === "low" &&
      expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT
    ) {
      dispatch(setdisabledLower(true))
      dispatch(setdisabledUpper(false))
    }
    if (curArch === "all") {
      dispatch(setdisabledUpper(false))
      dispatch(setdisabledLower(false))
      dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
      viewControlInTreatment.setViewType(ETopLeftViewType.FRONT)
    }
    return () => {
      dispatch(setdisabledUpper(false))
      dispatch(setdisabledLower(false))
    }
  }, [curArch, expanded])

  /**
   * 校验是否有调整计划
   */
  const checkGMDisabled = (GMData) => {
    if (GMData) {
      const upLength = GMData.jointUpKeypoints.length
      const lowLength = GMData.jointLowerKeypoints.length
      if (upLength || lowLength) {
        setDisabledGM(false)
      } else {
        setDisabledGM(true)
      }
    }
  }

  /**
   * Pontic Dome
   */
  const initPonticDomeModule = async (isInit: boolean) => {
    if (!isInit) {
      setIsShowPonticDome(false)
      wasmModule.statusController.SwitchDomePonticMenu(false)
      return
    }
    MyCurArch.current = "up"
    dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
    viewControlInTreatment?.setViewType(ETopLeftViewType.FRONT)
  }

  /**
   * 监听modelType变化
   */
  useEffect(() => {
    if (!expanded) return
    const isSplitAndArch =
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded === ESteupModelType.ARCH_FORM
    const isSplitAndIPR =
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT
    const isSplitAndPontic =
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded === ESteupModelType.PONTIC_DOME
    const isSplitAndGM =
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded === ESteupModelType.GLOBAL_MOVEMENT

    if (isSplitAndArch || isSplitAndPontic || isSplitAndGM) {
      dispatch(setTopLeftViewType(ETopLeftViewType.SPLIT))
      viewControlInTreatment.setViewType(ETopLeftViewType.SPLIT)

      setExpanded(null)
    }
  }, [expanded, topLeftViewType])

  const initView = async () => {
    dispatch(setCurArch("all"))
    MyCurArch.current = "all"
    dispatch(setdisabledUpper(false))
    dispatch(setdisabledLower(false))
    dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
    viewControlInTreatment?.setViewType(ETopLeftViewType.FRONT)
  }

  // 监听Stage 变化，控制GM是否开启
  useEffect(() => {
    const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
    const hasLower = wasmModule.getArchModel(EArchType.LowArch)
    if (!hasUpper || !hasLower) {
      setDisabledGM(true)
      return
    } else {
      setDisabledGM(false)
    }

    const GMData = getWasmStageData()
    checkGMDisabled(GMData)

    timer.current = setInterval(() => {
      const GMData = getWasmStageData()
      checkGMDisabled(GMData)
    }, 1500)

    return () => {
      if (timer.current) {
        clearTimeout(timer.current)
        timer.current = null
      }
    }
  }, [])

  useEffect(() => {
    if (expanded === ESteupModelType.GLOBAL_MOVEMENT && disabledGM) {
      setExpanded(null)
    }
  }, [expanded, disabledGM])

  /**
   * Watch Collision Check
   */
  useEffect(() => {
    if (
      openCollisionCheck &&
      expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT
    ) {
      if (!wasmModule.isFinishedOpencase) return
      const iprModule = wasmModule.moduleManager.GetIPRModule()
      if (iprModule) iprModule.ChangeShowZeroMode(true)
    }
  }, [openCollisionCheck])

  useEffect(() => {
    return () => {
      initView()
    }
  }, [])

  //GM Close
  useEffect(() => {
    if (
      expanded === ESteupModelType.GLOBAL_MOVEMENT &&
      MyCurArch.current !== curArch
    ) {
      MyCurArch.current = curArch
      if (isShowExtractedMsg) {
        dispatch(setIsShowExtractedMsg(false))
      }
      toothMovement.setIsEnableMoveTooth(true)
      wasmModule.moduleManager.SwitchAttachmentModule(true)
      globalMovement.ToggleLowerArchMove(false)
      setExpanded(null)
    }
  }, [curArch])

  /**
   * Init Status
   */
  const initStatus = async () => {
    if (
      topLeftViewType === ETopLeftViewType.SPLIT &&
      expanded !== ESteupModelType.IPRN_SPACE_MANAGEMENT
    ) {
      dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
      viewControlInTreatment.setViewType(ETopLeftViewType.FRONT)
      wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
    }
  }

  /**
   * clear previous panel status
   */
  const cleanupPreviousPanel = async (previousPanel: ESteupModelType) => {
    if (previousPanel === ESteupModelType.PONTIC_DOME) {
      initView()
    } else if (previousPanel === ESteupModelType.IPRN_SPACE_MANAGEMENT) {
      initView()
    } else if (previousPanel === ESteupModelType.GLOBAL_MOVEMENT) {
      MyCurArch.current = "all"
      dispatch(setCurArch("all"))
    }
  }
  const handleAccordionExited = async () => {
    // if (topLeftViewType === ETopLeftViewType.SPLIT && !pendingPanel) {
    //   setTimeout(() => {
    //     dispatch(setOpenCollisionCheck(false))
    //   }, 0)
    // }
    if (pendingPanel) {
      // 1. clear previous panel status
      await cleanupPreviousPanel(expanded as ESteupModelType)

      // 2.init new
      if (pendingPanel === ESteupModelType.ARCH_FORM) {
        dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
        viewControlInTreatment?.setViewType(ETopLeftViewType.FRONT)
      }

      if (pendingPanel === ESteupModelType.PONTIC_DOME) {
        MyCurArch.current = "up"
        dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
        viewControlInTreatment?.setViewType(ETopLeftViewType.FRONT)
      }
      if (pendingPanel === ESteupModelType.IPRN_SPACE_MANAGEMENT) {
        if (curArch === "all") {
          const upIsRetainer = isRetainerArch(EArchType.UpArch)
          if (upIsRetainer) {
            MyCurArch.current = "low"
          } else {
            MyCurArch.current = "up"
          }
        }
      }
      if (pendingPanel === ESteupModelType.GLOBAL_MOVEMENT) {
        MyCurArch.current = "all"
        await dispatch(setCurArch("all"))
        if (topLeftViewType === ETopLeftViewType.SPLIT) {
          await dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
          viewControlInTreatment?.setViewType(ETopLeftViewType.FRONT)
        }
      }
      setExpanded(pendingPanel)
      setPendingPanel(null)
      setIsSwitching(false)
    }
  }

  const handleChange = async (panel: ESteupModelType, isExpanded: boolean) => {
    console.log(
      "handleChange",
      expanded,
      panel,
      isExpanded,
      curArch,
      isSwitching,
    )
    if (isSwitching) return

    if (expanded && expanded !== panel && isExpanded) {
      setIsSwitching(true)
      setPendingPanel(panel)
      setExpanded(null)
    } else {
      if (panel === ESteupModelType.IPRN_SPACE_MANAGEMENT) {
        const upIsRetainer = isRetainerArch(EArchType.UpArch)
        if (upIsRetainer) {
          MyCurArch.current = "low"
        } else {
          MyCurArch.current = "up"
        }
      }
      if (panel === ESteupModelType.PONTIC_DOME) {
        initPonticDomeModule(isExpanded)
      }
      if (panel === ESteupModelType.GLOBAL_MOVEMENT) {
        MyCurArch.current = "all"
        await dispatch(setCurArch("all"))
        if (topLeftViewType === ETopLeftViewType.SPLIT) {
          await dispatch(setTopLeftViewType(ETopLeftViewType.FRONT))
          viewControlInTreatment?.setViewType(ETopLeftViewType.FRONT)
        }
      }

      setExpanded(isExpanded ? panel : null)
    }
  }

  return (
    <>
      <Backdrop
        className="my-backdrop-style"
        sx={{ color: "#215ecd", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={pageLoading}
        onClick={() => setPageLoading(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/*Arch Form*/}
      <Accordion
        className={classNames("accordion-common-style card-item", {
          "card-item-active": expanded === ESteupModelType.ARCH_FORM,
        })}
        disabled={disabledArchForm}
        TransitionProps={{
          unmountOnExit: true,
          onExited: handleAccordionExited,
        }}
        expanded={expanded === ESteupModelType.ARCH_FORM}
        onChange={(e: any, isExpanded: boolean) =>
          handleChange(ESteupModelType.ARCH_FORM, isExpanded)
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
          id="arch-form-header"
        >
          <h3 className="card-item-title">Arch Form</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-content" onClick={initStatus}>
          <ArchForm
            curArch={curArch}
            setType={setType}
            type={type}
            setExpanded={setExpanded}
          />
        </AccordionDetails>
      </Accordion>

      {/*IPR / Space Management*/}
      <Accordion
        className={classNames("accordion-common-style card-item", {
          "card-item-active":
            expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT,
        })}
        disabled={disabledIPR}
        TransitionProps={{
          unmountOnExit: true,
          onExited: handleAccordionExited,
        }}
        expanded={expanded === ESteupModelType.IPRN_SPACE_MANAGEMENT}
        onChange={(e: any, isExpanded: boolean) =>
          handleChange(ESteupModelType.IPRN_SPACE_MANAGEMENT, isExpanded)
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
          id="IPR-header"
        >
          {/* <h3 className="card-item-title">IPR / Space Mgmt.</h3> */}
          <h3 className="card-item-title">Space Management</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-content" onClick={initStatus}>
          <IPRSpaceManagement
            curArch={curArch}
            setPageLoading={setPageLoading}
          />
        </AccordionDetails>
      </Accordion>

      {/*Pontic / Dome*/}
      <Accordion
        className={classNames("accordion-common-style card-item", {
          "card-item-active": expanded === ESteupModelType.PONTIC_DOME,
        })}
        TransitionProps={{
          unmountOnExit: true,
          onExited: handleAccordionExited,
        }}
        expanded={expanded === ESteupModelType.PONTIC_DOME}
        onChange={(e: any, isExpanded: boolean) =>
          handleChange(ESteupModelType.PONTIC_DOME, isExpanded)
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
          id="PD-header"
        >
          <h3 className="card-item-title">Pontic / Dome</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-content" onClick={initStatus}>
          <PonticDome
            curArch={curArch}
            isShow={isShowPonticDome}
            setIsShow={setIsShowPonticDome}
          />
        </AccordionDetails>
      </Accordion>

      {/*Global Movement*/}
      <Accordion
        className={classNames("accordion-common-style card-item", {
          "card-item-active": expanded === ESteupModelType.GLOBAL_MOVEMENT,
        })}
        disabled={disabledGM || disabledGMModel}
        TransitionProps={{
          unmountOnExit: true,
          onExited: handleAccordionExited,
        }}
        expanded={expanded === ESteupModelType.GLOBAL_MOVEMENT}
        onChange={(e: any, isExpanded: boolean) =>
          handleChange(ESteupModelType.GLOBAL_MOVEMENT, isExpanded)
        }
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
          id="GM-header"
        >
          <h3 className="card-item-title">Global Movement</h3>
        </AccordionSummary>
        <AccordionDetails className="accordion-content" onClick={initStatus}>
          <GlobalMovement setPageLoading={setPageLoading} />
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default MyAccordion
